<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">
        {{ $t("distributorSummary") }}
      </div>

      <div class="mt-3 border-bottom">
        <div class="row">
          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="fromDate"
                  @selected="onSelectDate($event, 'from')"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">Show From Date</label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <!-- disabled -->
                <label :class="toDate ? 'active' : ''">Show To Date</label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label :class="selectedCinema ? 'shift-up' : ''">
                  {{ "Select Cinema" }}
                </label>

                <multiselect
                  v-model="selectedCinema"
                  @select="onSelectHandler($event, 'cinema')"
                  @remove="onRemoveHandler($event, 'cinema')"
                  placeholder=""
                  :options="Cinemas"
                  label="cine_name"
                  track-by="cine_id"
                  :multiple="false"
                  name="cine_id"
                  id="cine_id"
                  select-label="Select"
                  deselect-label="Remove"
                >
                </multiselect>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label
                  :class="selectedDistributor.length > 0 ? 'shift-up' : ''"
                >
                  {{ "Distributor" }}
                </label>

                <multiselect
                  v-model="selectedDistributor"
                  @input="onSelectHandler($event, 'distributor')"
                  @remove="onRemoveHandler($event, 'distributor')"
                  placeholder=""
                  :options="getDistributorReportDropdownList"
                  label="d_company_name"
                  track-by="d_id"
                  :multiple="true"
                  name="d_id"
                  id="d_id"
                  select-label="Select"
                  deselect-label="Remove"
                >
                </multiselect>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label :class="selectedMovie.length > 0 ? 'shift-up' : ''">
                  {{ "Movie" }}
                </label>

                <multiselect
                  v-model="selectedMovie"
                  @select="onSelectHandler($event, 'movie')"
                  @remove="onRemoveHandler($event, 'movie')"
                  placeholder=""
                  :options="MovieList"
                  label="movie_title"
                  track-by="movie_id"
                  :multiple="true"
                  name="movie_id"
                  id="movie_id"
                  select-label="Select"
                  deselect-label="Remove"
                >
                </multiselect>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label :class="selectedTable.table_name ? 'shift-up' : ''">
                  {{ "Select Table" }}
                </label>

                <multiselect
                  v-model="selectedTable"
                  placeholder=""
                  @input="changeTableData"
                  :options="selectedTableDropDown"
                  label="table_name"
                  track-by="table_id"
                  :multiple="false"
                  name="table_id"
                  id="table_id"
                  select-label="Select"
                >
                </multiselect>
              </div>
            </div>
          </div>
          <div
            class="col-lg-6 col-xl-3 align-self-center mb-3"
            v-if="isCinemaAkhil"
          >
            <div class="dropdown-curve-container">
              <label :class="selectedCategoryName ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("Category", 1) }}</label
              >
              <multiselect
                v-model="selectedScheduleCategory"
                track-by="ss_category_id"
                label="ss_category_name"
                @select="onSelectScheduleCategory($event, $event)"
                @remove="onRemoveSelectScheduleCategory($event, $event)"
                :options="scheduleCategoryList"
                :multiple="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent.stop="fDistributorReportList"
            >
              {{ $tc("Fetch Report") }}
            </button>
          </div>

          <!--  -->
          <div
            v-if="DistributorCollection.length > 0"
            class="d-flex justify-content-end align-items-center col-lg-6 col-xl-3 align-self-center mb-3"
          >
            <div class="mr-2">Download as:</div>
            <a
              v-if="PDFName"
              :href="REPORT_URL + PDFName"
              target="_blank"
              download
              title="Download as PDF"
            >
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>

            <a
              v-if="ExcelName"
              :href="REPORT_URL + ExcelName"
              target="_blank"
              title="Download as Excel"
              download
            >
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </a>
          </div>
        </div>
      </div>
      <div class="swc-report" v-if="DistributorCollection.length == 0">
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th class="text-left">Distributor</th>
              <th class="text-left">Movie Name</th>
              <th class="text-left">Show Date</th>
              <th>Show Time</th>
              <th>Screen</th>
              <th>Class</th>
              <th>Ticket Type</th>
              <th>No of Tkts</th>
              <th>Comp. Tkts</th>
              <th>Total Tkts</th>
              <th>Price/Tkt</th>
              <th>Amt(incl Tax)</th>
              <th>Tax</th>
              <th v-if="CLIENT_NAME.EMPIRE == CLIENT_SETUP_NAME">GCAM</th>
              <th v-if="CLIENT_NAME.EMPIRE == CLIENT_SETUP_NAME">
                {{ "Net Amt" }}
              </th>
              <th class="_net2">
                {{
                  CLIENT_NAME.EMPIRE == CLIENT_SETUP_NAME
                    ? "Effective Net"
                    : "Net Amt"
                }}
              </th>
              <th>Dist %</th>
              <th>Dist.Comm</th>
              <th>Occ %</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="17">
                <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        v-if="DistributorCollection.length > 0"
        class="swc-report table-scroll"
      >
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th class="text-left">Distributor</th>
              <th class="text-left">Movie Name</th>
              <th class="text-left">Show Date</th>
              <th>Show Time</th>
              <th>Screen</th>
              <th>Class</th>
              <th>Ticket Type</th>
              <th>No of Tkts</th>
              <th v-if="selectedTable.table_name == 'With Complimentary'">
                Comp. Tkts
              </th>
              <th v-if="selectedTable.table_name == 'With Complimentary'">
                Total Tkts
              </th>
              <th>Price/Tkt</th>
              <th>Amt(incl Tax)</th>
              <th>Tax</th>
              <th v-if="CLIENT_NAME.EMPIRE == CLIENT_SETUP_NAME">GCAM</th>
              <th v-if="CLIENT_NAME.EMPIRE == CLIENT_SETUP_NAME">
                {{ "Net Amt" }}
              </th>
              <th class="_net2">
                {{
                  CLIENT_NAME.EMPIRE == CLIENT_SETUP_NAME
                    ? "Effective Net"
                    : "Net Amt"
                }}
              </th>
              <th v-if="CLIENT_NAME.EMPIRE != CLIENT_SETUP_NAME">
                Amt (excl. comp.)
              </th>
              <th>Dist %</th>
              <th>Dist.Comm</th>
              <th>Occ %</th>
            </tr>
          </thead>

          <tbody>
            <template
              v-for="(item, itemIndex) in DistributorCollection"
              class="mb-5"
            >
              <template v-for="disMovie in item">
                <tr v-for="(show, showIndex) in disMovie.Data" :key="showIndex">
                  <td
                    class="text-left"
                    v-if="showIndex == 0"
                    :rowSpan="disMovie.Data.length"
                  >
                    {{ show.dist_company_name }}
                  </td>
                  <td
                    class="text-left"
                    v-if="showIndex == 0"
                    :rowSpan="disMovie.Data.length"
                  >
                    {{ show.movie_name }}
                  </td>
                  <td class="text-left">
                    {{
                      show.display_date
                        ? moment(show.display_date, "DD-MM-YYYY").format(
                            "DD-MMM-YYYY"
                          )
                        : moment(show.show_date, "DD-MM-YYYY").format(
                            "DD-MMM-YYYY"
                          )
                    }}
                  </td>
                  <td>
                    {{ moment(show.t_show_time, "HH:mm").format("hh:mm a") }}
                  </td>
                  <td>{{ show.screen_name }}</td>
                  <td>{{ show.seat_type_name }}</td>
                  <td>{{ show.ticket_type_name }}</td>
                  <td>{{ show.Sold }}</td>
                  <td v-if="selectedTable.table_name == 'With Complimentary'">
                    {{ show.compplementory_ticket || 0 }}
                  </td>
                  <td v-if="selectedTable.table_name == 'With Complimentary'">
                    {{
                      parseInt(show.Sold || 0) +
                        parseInt(show.compplementory_ticket || 0)
                    }}
                  </td>
                  <td>{{ currFormat(show.rate) }}</td>
                  <td>
                    {{
                      checkClientName()
                        ? show["final_gross_amount"]
                          ? currFormat(show["final_gross_amount"])
                          : "-"
                        : show["final_gross_amount"]
                        ? currFormat(show["final_gross_amount"])
                        : "-"
                    }}
                  </td>
                  <td>
                    {{
                      checkClientName()
                        ? currFormat(
                            show.t_vat -
                              (show.t_vat * show.offerPercentage) / 100
                          )
                        : currFormat(show["total_taxes2"])
                    }}
                  </td>
                  <td
                    class="_gcam_amount"
                    v-if="CLIENT_NAME.EMPIRE == CLIENT_SETUP_NAME"
                  >
                    {{
                      currFormat(
                        show.t_gcam -
                          (show.t_gcam * show.offerPercentage) / 100 || 0
                      )
                    }}
                  </td>
                  <td>
                    {{
                      checkClientName()
                        ? currFormat(
                            show.final_gross_amount -
                              (show.t_vat -
                                (show.t_vat * show.offerPercentage) / 100)
                          )
                        : currFormat(show["net_revenue2"])
                    }}
                  </td>
                  <td class="_net2">
                    {{
                      checkClientName()
                        ? currFormat(
                            show["final_gross_amount"] -
                              (show.t_vat -
                                (show.t_vat * show.offerPercentage) / 100) -
                              (show.t_gcam -
                                (show.t_gcam * show.offerPercentage) / 100)
                          )
                        : currFormat(show["final_gross_amount"])
                    }}
                  </td>
                  <td>{{ currFormat(show["distributorShareInPercent"]) }} %</td>
                  <td>{{ currFormat(show["distributorShare"]) }}</td>
                  <td>
                    {{
                      currFormat(
                        (show["total_ticket"] / show["seat_count"]) * 100
                      )
                    }}
                  </td>
                </tr>
              </template>
              <tr :key="itemIndex" class="color-blue">
                <th colspan="1">Final Total</th>
                <th colspan="1">No. of Shows = {{ item.length }}</th>
                <th colspan="5"></th>
                <th>
                  {{
                    item.reduce(function(a, b) {
                      b.Data.forEach(function(c) {
                        a += c.Sold;
                      });
                      return a;
                    }, 0) || "-"
                  }}
                </th>
                <th v-if="selectedTable.table_name == 'With Complimentary'">
                  {{
                    item.reduce(function(a, b) {
                      b.Data.forEach(function(c) {
                        a += c.compplementory_ticket;
                      });
                      return a;
                    }, 0)
                  }}
                </th>
                <th v-if="selectedTable.table_name == 'With Complimentary'">
                  {{
                    item.reduce(function(a, b) {
                      b.Data.forEach(function({
                        total_ticket,
                        compplementory_ticket,
                      }) {
                        a =
                          a +
                          parseInt(total_ticket || 0) +
                          parseInt(compplementory_ticket || 0);
                      });
                      return a;
                    }, 0)
                  }}
                </th>
                <th></th>
                <th>
                  {{
                    checkClientName()
                      ? currFormat(
                          item.reduce(function(a, b) {
                            b.Data.forEach(function(c) {
                              a += parseFloat(c.final_gross_amount);
                            });
                            return a;
                          }, 0)
                        )
                      : currFormat(
                          item.reduce(function(a, b) {
                            b.Data.forEach(function(c) {
                              a += parseFloat(c.final_gross_amount);
                            });
                            return a;
                          }, 0)
                        ) || "-"
                  }}
                </th>
                <th>
                  {{
                    checkClientName()
                      ? currFormat(
                          item.reduce(function(a, b) {
                            b.Data.forEach(function(c) {
                              a += parseFloat(
                                c.t_vat - (c.t_vat * c.offerPercentage) / 100
                              );
                            });
                            return a;
                          }, 0)
                        ) || "-"
                      : currFormat(
                          item.reduce(function(a, b) {
                            b.Data.forEach(function(c) {
                              a += parseFloat(c.total_taxes2);
                            });
                            return a;
                          }, 0)
                        )
                  }}
                </th>
                <th v-if="CLIENT_NAME.EMPIRE == CLIENT_SETUP_NAME">
                  {{
                    checkClientName()
                      ? currFormat(
                          item.reduce(function(a, b) {
                            b.Data.forEach(function(c) {
                              a += parseFloat(
                                c.t_gcam - (c.t_gcam * c.offerPercentage) / 100
                              );
                            });
                            return a;
                          }, 0)
                        )
                      : currFormat(
                          item.reduce(function(a, b) {
                            b.Data.forEach(function(c) {
                              a += parseFloat(c.t_gcam || 0);
                            });
                            return a;
                          }, 0)
                        ) || "-"
                  }}
                </th>
                <th v-if="CLIENT_NAME.EMPIRE == CLIENT_SETUP_NAME">
                  {{
                    currFormat(
                      item.reduce(function(a, b) {
                        b.Data.forEach(function(c) {
                          a += parseFloat(c.final_gross_amount);
                        });
                        return a;
                      }, 0) -
                        item.reduce(function(a, b) {
                          b.Data.forEach(function(c) {
                            a += parseFloat(
                              c.t_vat - (c.t_vat * c.offerPercentage) / 100 || 0
                            );
                          });
                          return a;
                        }, 0)
                    ) || "-"
                  }}
                </th>
                <th class="_net2">
                  {{
                    checkClientName()
                      ? currFormat(
                          item.reduce(function(a, b) {
                            b.Data.forEach(function(c) {
                              a += parseFloat(c.final_gross_amount);
                            });
                            return a;
                          }, 0) -
                            item.reduce(function(a, b) {
                              b.Data.forEach(function(c) {
                                a += parseFloat(
                                  c.t_vat -
                                    (c.t_vat * c.offerPercentage) / 100 || 0
                                );
                              });
                              return a;
                            }, 0) -
                            item.reduce(function(a, b) {
                              b.Data.forEach(function(c) {
                                a += parseFloat(
                                  c.t_gcam -
                                    (c.t_gcam * c.offerPercentage) / 100 || 0
                                );
                              });
                              return a;
                            }, 0)
                        )
                      : currFormat(
                          item.reduce(function(a, b) {
                            b.Data.forEach(function(c) {
                              a += parseFloat(c.final_gross_amount);
                            });
                            return a;
                          }, 0) -
                            item.reduce(function(a, b) {
                              b.Data.forEach(function(c) {
                                a += parseFloat(c.total_taxes2 || 0);
                              });
                              return a;
                            }, 0)
                        ) || "-"
                  }}
                </th>
                <th></th>
                <th></th>
                <th>
                  {{
                    currFormat(
                      item.reduce(function(a, b) {
                        b.Data.forEach(function(c) {
                          a += parseFloat(c.distributorShare);
                        });
                        return a;
                      }, 0)
                    ) || "-"
                  }}
                </th>
                <th></th>
              </tr>
              <tr :key="itemIndex" style="height: 40px"></tr>
            </template>
          </tbody>
        </table>
      </div>

      <hr class="my-2" />
      <div class="d-flex justify-content-between">
        <div
          v-if="
            complementaryFinalTable.length > 0 &&
              selectedTable.table_name == 'With Complimentary'
          "
          class="section-title mb-3"
        >
          complimentary Summary
        </div>
        <div
          v-if="
            complementaryFinalTable.length > 0 &&
              selectedTable.table_name == 'With Complimentary'
          "
          class="d-flex justify-content-end mt-2 align-items-center"
        >
          <div class="mr-2">Download as:</div>
          <img
            @click="excelDownload()"
            class="mx-1"
            src="@/assets/img/icons/excel.svg"
            height="25"
            width="25"
          />
        </div>
      </div>

      <div
        class="mt-2"
        style="text-align: right"
        v-if="
          complementaryFinalTable.length > 0 &&
            selectedTable.table_name == 'With Complimentary'
        "
      >
        <!-- <a target="_blank" title="Download as Excel" @click="excelDownload()">
            Download <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
      </a> -->
        <!-- <a target="_blank" @click="generateReport()" title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a> -->
      </div>
      <div
        v-if="
          complementaryFinalTable.length > 0 &&
            selectedTable.table_name == 'With Complimentary'
        "
        class="swc-report table-scroll"
      >
        <table class="swc-report-table" border="1">
          <thead class="color-blue font-weight-bold">
            <tr>
              <th>Distributor</th>
              <th>Cinema Name</th>
              <th>Movie Name</th>
              <th>Show Date</th>
              <th>Screen</th>
              <th>Show Time</th>
              <th>Comp. Tickets</th>
              <th>Price/Tkt</th>
              <th>Amt(Incl. Tax)</th>
            </tr>
          </thead>
          <template
            v-for="(summaryData, summaryDataIndex) in complementaryFinalTable"
          >
            <tr :key="summaryDataIndex + 'SummaryData'">
              <td
                class="text-left"
                :rowspan="summaryData.price_details.length + 1"
              >
                {{ summaryData.dist_company_name }}
              </td>
              <td
                class="text-left"
                :rowspan="summaryData.price_details.length + 1"
              >
                {{ summaryData.cinema_name }}
              </td>
              <td
                class="text-left"
                :rowspan="summaryData.price_details.length + 1"
              >
                {{ summaryData.movie_name }}
              </td>
              <td
                class="text-left"
                :rowspan="summaryData.price_details.length + 1"
              >
                {{ summaryData.show_date }}
              </td>
              <td
                class="text-left"
                :rowspan="summaryData.price_details.length + 1"
              >
                {{ summaryData.screen_name }}
              </td>
              <td
                class="text-left"
                :rowspan="summaryData.price_details.length + 1"
              >
                {{ summaryData.t_show_time }}
              </td>
            </tr>
            <template
              v-for="(compData, compDataIndex) in summaryData.price_details"
            >
              <tr :key="compDataIndex + 'compData'">
                <td class="text-right">{{ compData.complimentary_count }}</td>
                <td class="text-right">
                  {{ compData.rate.toFixed(MIN_FRACTION_DIGITS) }}
                </td>
                <td class="text-right">
                  {{ compData.totalRate.toFixed(MIN_FRACTION_DIGITS) }}
                </td>
              </tr>
            </template>
          </template>
          <tr class="color-blue font-weight-bold">
            <td class="text-left" colspan="6">Total</td>
            <td class="text-right">{{ complementaryGrandTotal.comp_total }}</td>
            <td class="text-right"></td>
            <td class="text-right">
              {{
                complementaryGrandTotal.comp_rate_total.toFixed(
                  MIN_FRACTION_DIGITS
                )
              }}
            </td>
            <!-- <td class="text-right">
              {{ complementaryGrandTotal.price_total }}
            </td> -->
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import { Role, CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";
  import { mapState, mapGetters, mapActions } from "vuex";
  import { movieWeekEnd } from "@/helper/collection";
  import moment from "moment";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/ReportsService";
  import { authenticationService } from "@/services/AuthenticationService";
  import xlsx from "json-as-xlsx";

  export default {
    data() {
      return {
        scheduleCategoryList: [],
        selectedScheduleCategoryId: null,
        selectedCategoryName: "",
        selectedScheduleCategory: {},
        CLIENT_NAME,
        FilePathArray: [],
        MovieList: [],
        PDFName: "",
        ExcelName: "",
        DistributorCollection: [],
        FinalTotalCharges: [],
        Cinemas: [],
        selectedCinema: "",
        cinema_id: null,
        selectedDistributor: [],
        d_id: null,
        selectedMovie: [],
        movie_id: null,
        fromDate: new Date(),
        toDate: new Date(),
        isRoleID: true,
        CinemasCopy: [],
        searchCinema: "",
        complementaryCheckStatus: "N",
        complementarySummaryTable: [],
        complementaryFinalTable: [],
        complementaryGrandTotal: {
          comp_total: 0,
          price_total: 0,
        },
        selectedTable: {
          table_id: 2,
          table_name: "With Complimentary",
        },
        selectedTableDropDown: [
          {
            table_id: 1,
            table_name: "Without Complimentary",
          },
          {
            table_id: 2,
            table_name: "With Complimentary",
          },
        ],
      };
    },
    // watch: {
    //   complementaryCheckStatus: function(val) {
    //     this.complementaryCheckStatus = val;
    //   }
    // },
    computed: {
      isCinemaAkhil() {
        return CLIENT_NAMES_OBJ.cinemaakhil == this.CLIENT_SETUP_NAME;
      },
      ...mapGetters([
        // GET LIST ONLY FROM MASTER STORE
        "getCinemasList",

        // Selected Dropdowns
        "getDistributorReportSelectedMovie",
        "getDistributorReportSelectedCinema",
        "getDistributorReportSelectedDistributor",
        // Flags
        "getDistributorReportsIsCinema",
        "getDistributorReportsIsDistributor",
        // Selected Dates
        "getDistributorReportToDate",
        "getDistributorReportFromDate",
        // Get List
        "getDistributorReportList",
        "getDistributorReportDropdownList",
        "getDistributorReportMoviesList",
        "getDistributorReportChargeList",
        "getdistributorReportsListV2",
        // GET EXCEL FILE
        "getDistributorExcelFileName",
        // PDF
        "getDistributorPDFFileName",

        // GET WEEK DATA
        "getDateWeekData",
        //
        "getReleaseDate",
        "getWeekStartDay",

        "getDistributorReportSelectedMovieId",
        "getDistributorReportSelectedDistributorId",
        "getDistributorReportSelectedCinemaId",
        "getIfNoDataInDateRange",
      ]),
      distributorIds() {
        let text = ``;
        if (this.selectedDistributor.length > 0) {
          text = this.selectedDistributor.map((x) => x.d_id).join(",");
        }

        return text;
      },
      movieIds() {
        let text = ``;
        if (this.selectedMovie.length > 0) {
          text = this.selectedMovie.map((x) => x.md_id).join(",");
        }

        return text;
      },
      validateTicketCount() {
        let count = 0;
        this.DistributorCollection.map((x) => {
          x.map((y) => {
            y.Data.map((z) => {
              count += parseFloat(z.Sold);
            });
          });
        });
        return count;
      },
      countShow() {
        let obj = {
          distributorShare: 0,
          net_revenue2: 0,
          total_ticket_tax: 0,
          gross_receipts: 0,
          complementory_sold: 0,
          tickets_sold: 0,
        };
        let showCount = 0;
        if (this.getdistributorReportsListV2.FinalResult.length > 0) {
          this.getdistributorReportsListV2.FinalResult.map((x) => {
            x.Shows.map((showw) => {
              showCount = showw.seat_types.length + showCount;
              showw.seat_types.map((stt) => {
                Object.keys(obj).map((z) => {
                  obj[z] = parseFloat(obj[z] + stt[z]);
                });
              });
            });
          });
        }
        obj["showCount"] = showCount;
        return obj;
      },

      getStartDate() {
        let filterArray = [];
        filterArray = this.getdistributorReportsListV2.finalWeekArray.filter(
          (x) => x.sum.Shows > 0
        );
        if (filterArray.length > 0) {
          return filterArray[0].date[0];
        } else {
          return moment().format("YYYY-MM-DD");
        }
      },

      getEndDate() {
        let filterArray = [];
        filterArray = this.getdistributorReportsListV2.finalWeekArray.filter(
          (x) => x.sum.Shows > 0
        );
        if (filterArray.length > 0) {
          let lastElement = filterArray.pop();
          return lastElement.date[lastElement.date.length - 1];
        } else {
          return moment().format("YYYY-MM-DD");
        }
      },
      getArrayOfWeekCollection() {
        let filterArray = [];
        let TempArray = [];
        filterArray = this.getdistributorReportsListV2.finalWeekArray.filter(
          (x) => x //.sum.Shows > 0
        );
        if (filterArray.length > 0) {
          filterArray.map((x) => {
            let obj = {
              distributor_id: this.getDistributorReportSelectedDistributorId,
              cinema_id: this.getDistributorReportSelectedCinemaId,
              md_id: this.getDistributorReportSelectedMovieId,
              fromDate: x.date[0],
              toDate: x.date[x.date.length - 1],
              week: x.name.split(" ")[1],
            };
            TempArray.push(obj);
          });
        }
        return TempArray;
      },
    },
    beforeMount() {
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
      }
      let distributorId = this.secureStore.get("USINFO")["distributor_id"];
      console.log("dis::::::::::::: :", distributorId);
      let cinemaId =
        this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO")["cinema_id"]
          ? this.secureStore.get("USINFO").cinema_id
          : null;
      this.getCinemaList(cinemaId);

      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      if (CinemaObj) {
        this.onSelectHandler(CinemaObj, "cinema");
      }

      // if (distributorId) {
      //   this.onDistributorReportFlagHandler({
      //     event: null,
      //     name: "isDistributor",
      //     value: distributorId
      //   });
      // }
      this.fetchCinemasList({ cinemaId });
      this.fetchReportDistributorsList();
      this.getShowScheduleCategories();
    },
    created() {
      window.addEventListener("unload", (event) => {
        this.removeDownloadedFile();
      });
    },
    beforeDestroy() {
      this.removeDownloadedFile();
    },
    mounted() {},
    methods: {
      getShowScheduleCategories() {
        let payload = {
          tableName: "schedule_show_categories",
          is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.scheduleCategoryList = data.Records.reverse();
            } else {
              // Show Error Message:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getActiveScreenByCinemaId :", error);
          });
      },
      onSelectScheduleCategory(event, category) {
        console.log("selectCategory=>");
        this.selectedCategoryName = category.ss_category_name;
        this.selectedScheduleCategoryId = category.ss_category_id;
        this.selectedScheduleCategory = category;
        // this.isChanged = true;
      },
      onRemoveSelectScheduleCategory() {
        console.log("selectCategory=>");
        this.selectedScheduleCategoryId = null;
        this.selectedCategoryName = "";
        this.selectedScheduleCategory = null;
      },
      checkClientName() {
        console.log(CLIENT_NAME.EMPIRE, this.CLIENT_SETUP_NAME);
        return CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME;
      },
      excelDownload() {
        let temp_data = this.complementaryFinalTable;
        let temp_arr = [];
        temp_data.map((x) => {
          x.price_details.map((y) => {
            let obj = {
              ...x,
              ...y,
            };
            temp_arr.push(obj);
          });
        });
        console.log({ temp_arr });
        let dateparse = function(value) {
          if (!value) return "-";
          else if (value === "Invalid date") return "-";
          else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
            return value
              ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY")
              : "-";
          //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
          //this is changed acc to mams decision
          else
            return value
              ? moment(value).format("DD-MM-YYYY") === "Invalid date"
                ? "-"
                : moment(value).format("DD-MMM-YYYY")
              : "-";
        };
        let fulldatemonparse = function(value) {
          if (!value) return "-";
          else if (value === "Invalid date") return "-";
          else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
            return value
              ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY HH:mm")
              : "-";
          //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
          //this is changed acc to mams decision
          else
            return value
              ? moment(value).format("DD-MM-YYYY") === "Invalid date"
                ? "-"
                : moment(value).format("DD-MMM-YYYY HH:mm")
              : "-";
        };

        let data = [
          {
            sheet: "Complimentary Summary",
            columns: [
              {
                value: "dist_company_name",
                label: "Distributor",
              },
              {
                value: "cinema_name",
                label: "Cinema Name",
              },
              {
                value: "movie_name",
                label: "Movie Name",
              },
              {
                value: "show_date",
                label: "Show Date",
              },
              {
                value: "screen_name",
                label: "Screen",
              },

              {
                value: "t_show_time",
                label: "Show Time",
              },

              {
                value: "complimentary_count",
                label: "Comp. Tickets",
              },
              {
                value: (row) =>
                  +parseFloat(row.rate).toFixed(this.MIN_FRACTION_DIGITS),
                label: "Price/Tkt",
              },
              {
                value: (row) =>
                  +parseFloat(row.totalRate).toFixed(this.MIN_FRACTION_DIGITS),
                label: "Amt(Incl. Tax)",
              },
            ],
            content: temp_arr,
          },
        ];
        let settings = {
          fileName: `ComplimentarySummary${new Date().getTime()}`,
        };
        xlsx(data, settings);
      },
      moment,
      changeTableData() {
        this.complementaryFinalTable = [];
        this.DistributorCollection = [];
        this.fDistributorReportList();
      },
      onSelectDate(e, type) {
        if (type == "from") {
          this.toDate = new Date(e);
          this.$forceUpdate();
        }
        this.selectedDistributor = [];
        this.selectedMovie = [];
        this.$forceUpdate();
      },
      fetchDistributorMovies() {
        if (!this.cinema_id) {
          this.$toasted.show("Please Select Cinema");
          this.selectedDistributor = [];
          this.$forceUpdate();
        } else {
          this.MovieList = [];
          let payload = {
            fromDate: this.fromDate,
            toDate: this.toDate,
            cinema_id: this.cinema_id,
            cinema_name: this.selectedCinema.cine_name,
            d_id: this.distributorIds,
            d_company_name: this.selectedDistributor
              .map((x) => x.d_company_name)
              .join(","),
            country_id: authenticationService.get("BRGLOPCO"),
            filter_with_key: "ss_actual_start_date",
          };
          ReportsService.GetDistributorMovieFormat(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status && data.Records) {
                this.MovieList = data.Records;
              } else
                this.$toasted.show(
                  data.message || "Opps! Something went wrong"
                );
            })
            .catch((error) => {
              this.$toasted.show(
                "Catch Error on ReportStore fetchDistributorMovies",
                error
              );
            });
        }
      },
      fDistributorReportList: async function() {
        console.log("this.fromDate", this.fromDate);
        console.log("this.toDate", this.toDate);
        let fromDate = moment(new Date(this.fromDate)).format("YYYY-MM-DD");
        let toDate = moment(new Date(this.toDate)).format("YYYY-MM-DD");

        console.log("fromDate", fromDate);
        console.log("toDate", toDate);
        this.DistributorCollection = [];
        this.complementaryFinalTable = [];
        if (new Date(fromDate) > new Date(toDate)) {
          this.$toasted.show("From date should not be greater than To date.");
        } else if (!this.cinema_id) {
          this.$toasted.show("Please Select any Cinema.");
        } else {
          let loader = this.$loading.show();

          let payload = {
            fromDate: fromDate,
            toDate: toDate,
            cinema_id: this.cinema_id,
            cinema_name: this.selectedCinema.cine_name,
            d_id: this.distributorIds,
            d_company_name: this.selectedDistributor
              .map((x) => x.d_company_name)
              .join(","),
            movie_id: this.movieIds,
            movie_title: this.selectedMovie.map((x) => x.movie_title).join(","),
            country_id: authenticationService.get("BRGLOPCO"),
            noDataInDateRange: false,
            weekWithNoSchedule: false,
            filter_with_key: "ss_actual_start_date",
            ss_show_category_id: this.selectedScheduleCategoryId
              ? this.selectedScheduleCategoryId
              : null,
            isComplementary:
              this.selectedTable.table_name == "With Complimentary" ? "Y" : "N",
          };
          console.log("payload", payload.isComplementary);

          ReportsService.GetDistributorReportListV4(payload)
            .then(async (response) => {
              const { data } = response;
              console.log(data, "datadata");
              if (data && data.status && data.data.length > 0) {
                // if (data && data.data.length > 0) {
                //   data.data.forEach(
                //     d1 => {
                //       if (d1.length) {
                //         d1.forEach(
                //           d => {
                //             if (d.Data && d.Data.length) {
                //               d.Data.forEach(
                //                 s => {
                //                   let gcamKey = Object.keys(s).filter(k => String(k.toUpperCase()).includes('GCAM'))
                //                   if (gcamKey.length) {
                //                     s.t_gcam = s[gcamKey[0]] || 0
                //                   } else {
                //                     s.t_gcam = 0
                //                   }
                //
                //                   let vatKey = Object.keys(s).filter(k => String(k.toUpperCase()).includes('VAT'))
                //                   if (vatKey.length) {
                //                     s.t_vat = 0
                //                     vatKey.forEach(k => {
                //                       s.t_vat += (s[k] || 0)
                //                     })
                //                   }
                //                 }
                //               )
                //             }
                //           }
                //         )
                //       }
                //     }
                //   )
                // }

                this.DistributorCollection = data.data;
                this.FinalTotalCharges = [];
                this.complementaryFinalTable = [];

                //summary table for complimentary tickets
                if (this.selectedTable.table_name == "With Complimentary") {
                  // data.data.map(a => {
                  //   a.map(b => {
                  //     if (b.Data.length) {
                  //       b.Data.map(c => {
                  //         if (c.compplementory_ticket > 0) {
                  //           this.DistributorCollection.push(a);
                  //         }
                  //       });
                  //     }
                  //   });
                  // });
                  // this.DistributorCollection = [...test_arr];
                  if (this.DistributorCollection.length) {
                    this.complementarySummaryTable = [];
                    let summaryTableInitialArr = this.complementarySummaryTable;
                    this.DistributorCollection.map((_dcArray1) => {
                      _dcArray1.map((_dcArray2) => {
                        _dcArray2.Data.map((x) => {
                          if (x.compplementory_ticket > 0) {
                            summaryTableInitialArr.push(x);
                          }
                        });
                      });
                    });
                    // let summaryTableFinalArr = [];
                    let summaryTableFinalArr = this.complementaryFinalTable;
                    summaryTableInitialArr.map((initialMap) => {
                      let findMovieIndex = summaryTableFinalArr.findIndex(
                        (indexObj) => {
                          return (
                            indexObj.movie_id == initialMap.movie_id &&
                            indexObj.show_date == initialMap.show_date &&
                            indexObj.t_show_time == initialMap.t_show_time &&
                            indexObj.screen_id == initialMap.screen_id &&
                            indexObj.cinema_id == initialMap.cinema_id &&
                            indexObj.d_id == initialMap.d_id
                          );
                        }
                      );
                      if (findMovieIndex < 0) {
                        let obj = {
                          movie_id: initialMap.movie_id,
                          show_date: initialMap.show_date,
                          t_show_time: initialMap.t_show_time,
                          screen_id: initialMap.screen_id,
                          t_show_time: initialMap.t_show_time,
                          d_id: initialMap.d_id,
                          dist_company_name: initialMap.dist_company_name,
                          screen_name: initialMap.screen_name,
                          movie_name: initialMap.movie_name,
                          cinema_name: initialMap.cinema_name,
                          price_details: [],
                        };
                        obj["price_details"].push({
                          rate: initialMap.rate,
                          complimentary_count: initialMap.compplementory_ticket,
                          totalRate:
                            initialMap.rate * initialMap.compplementory_ticket,
                        });
                        summaryTableFinalArr.push(obj);
                      } else {
                        let findPriceIndex = summaryTableFinalArr[
                          findMovieIndex
                        ]["price_details"].findIndex((priceIndex) => {
                          return priceIndex.rate == initialMap.rate;
                        });
                        summaryTableFinalArr["totalAmt"] += initialMap.rate;
                        if (findPriceIndex >= 0) {
                          summaryTableFinalArr[findMovieIndex]["price_details"][
                            findPriceIndex
                          ]["rate"] += +parseFloat(initialMap.rate);
                          summaryTableFinalArr[findMovieIndex]["price_details"][
                            findPriceIndex
                          ]["complimentary_count"] += +parseFloat(
                            initialMap.compplementory_ticket
                          );
                          summaryTableFinalArr[findMovieIndex]["price_details"][
                            findPriceIndex
                          ]["totalRate"] =
                            initialMap.rate * initialMap.compplementory_ticket;
                        } else {
                          summaryTableFinalArr[findMovieIndex][
                            "price_details"
                          ].push({
                            rate: initialMap.rate,
                            complimentary_count:
                              initialMap.compplementory_ticket,
                            totalRate:
                              initialMap.rate *
                              initialMap.compplementory_ticket,
                          });
                        }
                        // summaryTableFinalArr[findMovieIndex][
                        //   "complimentary_details"
                        // ].push(initialMap.compplementory_ticket);
                      }
                    });
                    if (this.complementaryFinalTable.length) {
                      this.complementaryGrandTotal = {
                        price_total: 0,
                        comp_total: 0,
                        comp_rate_total: 0,
                      };
                      this.complementaryFinalTable.map((compDataArr1) => {
                        compDataArr1.price_details.reduce((acc, { rate }) => {
                          return (this.complementaryGrandTotal.price_total +=
                            acc + rate);
                        }, 0);
                        compDataArr1.price_details.reduce(
                          (acc, { complimentary_count }) => {
                            return (this.complementaryGrandTotal.comp_total +=
                              acc + complimentary_count);
                          },
                          0
                        );
                        compDataArr1.price_details.reduce(
                          (acc, { complimentary_count, rate }) => {
                            return (this.complementaryGrandTotal.comp_rate_total +=
                              acc + complimentary_count * rate);
                          },
                          0
                        );
                      });
                    }
                  }
                }
                if (data.PDFName) {
                  this.PDFName = data.PDFName;
                  this.FilePathArray.push(data.PDFName);
                }
                if (data.ExcelName) {
                  this.ExcelName = data.ExcelName;
                  this.FilePathArray.push(data.ExcelName);
                }
              } else {
                this.toasted.show(data.message);
              }
            })
            .catch((error) => {
              console.log("ERROR:", error);
              this.DistributorCollection = [];
              this.complementaryFinalTable = [];
            })
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            });
        }
      },
      removeDownloadedFile() {
        let payload = {
          fileArray: this.FilePathArray,
        };
        MasterService.RemoveDownloadedFile(payload)
          .then((response) => {
            const { data } = response;
          })
          .catch((error) => {
            console.log("error :", error);
          });
      },
      onSelectHandler(event, type) {
        if (type == "cinema") {
          this.cinema_id = event.cine_id;
          this.selectedCinema = event;
          this.$store.dispatch("selectDropdownCinema", event);
        } else if (type == "distributor") {
          this.d_id = event.d_id;
          this.selectedMovie = [];
          this.MovieList = [];
          this.fetchDistributorMovies();
          // this.selectedDistributor = event;
        } else if (type == "movie") {
          this.movie_id = event.md_id;
          // this.selectedMovie = event;
        }
      },
      onRemoveHandler(event, type) {
        if (type == "cinema") {
          this.cinema_id = null;
          this.selectedCinema = "";
        } else if (type == "distributor") {
          this.d_id = null;
          // this.selectedDistributor = [];
        } else if (type == "movie") {
          this.movie_id = null;
          // this.selectedMovie = [];
        }
      },
      onSearchCinema: function() {
        if (this.searchCinema && this.searchCinema.length > 0) {
          this.Cinemas = this.CinemasCopy.filter((x) => {
            if (
              x.cine_name
                .toLowerCase()
                .includes(this.searchCinema.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.Cinemas = this.CinemasCopy;
        }
      },
      getCinemaList: function(cine_id) {
        this.Cinemas = [];
        MasterService.GetCinemasByRoles({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              this.CinemasCopy = data.Records;
              this.Cinemas.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  this.onDistributorReportFlagHandler({
                    event: null,
                    name: "isCinema",
                    value: x.cine_id,
                    cine_name: x.cine_name,
                  });
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      ...mapActions([
        // FETCH FROM MASTER STORE
        "fetchCinemasList",
        // "fetchDistributorsList",
        // "fetchDistributorsActiveMasterMovie",
        // FETCH LIST ONLY
        "fetchReportDistributorsList",
        "fetchDistributorReportList",
        "onDistributorReportDateHandler",
        "onDistributorReportDropdownHandler",
        "onDistributorReportFlagHandler",
        "onResetDistributorStoreState",
      ]),
      getWeekNumber: function(release_date, show_date, endDate, WeekStartDay) {
        let weekDay = this.getdistributorReportsListV2.finalWeekArray.filter(
          (x) => {
            return x.date.indexOf(moment(show_date).format("YYYY-MM-DD")) >= 0;
          }
        );
        console.log(weekDay, "Weeeed");
        return weekDay[0].name;
        return CountWeek;
      },
    },
  };
</script>

<style>
  .color-blue {
    background: #c1d7eb;
  }

  /* .align-last-center tr > th:last-child,
tr > td:last-child {
  text-align: center;
}

.align-first-left tr > th:first-child,
tr > td:first-child {
  text-align: left;
  padding-left: 2px;
}

.align-last-right tr > th:last-child,
tr > td:last-child {
  text-align: right;
  padding-right: 2px;
} */
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/distributorCollectionSummarynewAkil.vue